import { keepPreviousData } from '@tanstack/react-query';
import { useAppQuery } from 'core/query/hooks/useAppQuery';
import { teamQueryKeys } from 'TeamModule/query/teamQueryKeys';
import {
  searchTeamsByFieldsApi,
  SearchTeamsByFieldsPayload,
  SearchTeamsByFieldsResponse,
} from 'TeamModule/api/searchTeamsByFieldsApi';

export const useSearchTeamsByFieldsQuery = (
  params: SearchTeamsByFieldsPayload & { enabled?: boolean },
) => {
  const { enabled = true, ...rest } = params;

  const { data: queryData, ...query } = useAppQuery<{
    data: SearchTeamsByFieldsResponse;
  }>({
    queryKey: teamQueryKeys.list({
      identifier: `useSearchTeamsByFieldsQuery`,
      ...rest,
    }),
    queryFn: async ({ token, buildConfig }) => {
      // buildConfig() automatically includes URL context headers (tenant/realmId)
      const response = await searchTeamsByFieldsApi({ params: rest, token, config: buildConfig() });
      return { data: response.data as SearchTeamsByFieldsResponse };
    },
    staleTime: 30000, // 30 seconds - prevents aggressive refetching
    gcTime: 5 * 60 * 1000, // 5 minutes - keep data in cache longer
    refetchOnWindowFocus: false,
    refetchOnMount: false, // Don't refetch on mount if data exists
    placeholderData: keepPreviousData, // Keep previous data while fetching new data - prevents flash
    enabled,
  });

  return { teamsSearch: queryData?.data, ...query };
};

export default useSearchTeamsByFieldsQuery;
